import {
  getInviteSubUserUrl,
  getResendSubUserInviteUrl,
  getSubUserAssignAllRoomsUrl,
  getSubUserRoomsUrl,
  getSubUsersUrl,
  getSubUserUrl,
} from "./api-url.constants";
import { API_METHODS } from "../shared";
import { jsonFetch, typedFetch } from "@/lib/helpers";
import { SubUser } from "@/models/customer";

export type InviteSubUserParams = {
  customerId: string;
  username: string;
  email: string;
};

export type SetSubUserRoomsParams = {
  customerId: string;
  userId: string;
  roomIds: string[];
};

export type AssignAllRoomsParams = {
  customerId: string;
  userId: string;
};

export type RemoveSubUserParams = {
  customerId: string;
  userId: string;
};

export type GetSubUserRoomsParams = {
  customerId: string;
  userId: string;
};

export const inviteSubUser = async ({
  customerId,
  username,
  email,
}: InviteSubUserParams): Promise<string> => {
  const result = await jsonFetch<{ data: { userId: string } }>(getInviteSubUserUrl(customerId), {
    method: API_METHODS.POST,
    body: JSON.stringify({ username, email }),
  });
  return result.data.userId;
};

export const getSubUsers = async (customerId: string): Promise<SubUser[]> => {
  const result = await jsonFetch<{ data: { subUsers: SubUser[] } }>(getSubUsersUrl(customerId));
  return result.data.subUsers ?? [];
};

export const removeSubUser = async ({
  customerId,
  userId,
}: RemoveSubUserParams): Promise<boolean> => {
  const result = await typedFetch(getSubUserUrl(customerId, userId), {
    method: API_METHODS.DELETE,
  });
  return result.ok;
};

export const setSubUserRooms = async ({
  customerId,
  userId,
  roomIds,
}: SetSubUserRoomsParams): Promise<boolean> => {
  const result = await typedFetch(getSubUserRoomsUrl(customerId, userId), {
    method: API_METHODS.PUT,
    body: JSON.stringify({ roomIds }),
  });
  return result.ok;
};

export const assignAllRooms = async ({
  customerId,
  userId,
}: AssignAllRoomsParams): Promise<boolean> => {
  const result = await typedFetch(getSubUserAssignAllRoomsUrl(customerId, userId), {
    method: API_METHODS.POST,
  });
  return result.ok;
};

export const getSubUserRooms = async ({
  customerId,
  userId,
}: GetSubUserRoomsParams): Promise<string[]> => {
  const result = await jsonFetch<{ data: { roomIds: string[] } }>(
    getSubUserRoomsUrl(customerId, userId)
  );
  return result.data.roomIds ?? [];
};

export type ResendInviteParams = {
  customerId: string;
  userId: string;
};

export const resendSubUserInvite = async ({
  customerId,
  userId,
}: ResendInviteParams): Promise<boolean> => {
  const result = await typedFetch(getResendSubUserInviteUrl(customerId, userId), {
    method: API_METHODS.POST,
  });
  return result.ok;
};
